module.exports = __webpack_public_path__ + "img/cover_photo_babe.d4ab29f5.jpg";